import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1l0 -8","key":"svg-0"}]]

/**
 * IconBrandVisualStudio
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtdmlzdWFsLXN0dWRpbyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCA4bDIgLTFsMTAgMTNsNCAtMnYtMTJsLTQgLTJsLTEwIDEzbC0yIC0xbDAgLTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-visual-studio
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandVisualStudio = createReactComponent('outline', 'brand-visual-studio', 'BrandVisualStudio', __iconNode);

export default IconBrandVisualStudio;